/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { SortDirection } from 'cio/utils/sort';

interface CollectionDataDisplayArgs {
  items: Record<string, any>[];
  sortable: boolean;
  sortBy: string;
  sortDirection: SortDirection;
  onSort: (sortBy: string, sortDirection: SortDirection) => unknown;
  visibleColumns: string[];
}

export default class CollectionDataDisplay extends Component<CollectionDataDisplayArgs> {}
